// extracted by mini-css-extract-plugin
module.exports = {"subtitle":"http-method-name_subtitle__XmWHD"};